module.exports = __webpack_public_path__ + "img/lt_my_mission.29e2e9e7.png";